<template>
  <div style="padding: 0; text-align: left">
    <div class="p1">
      <mx-element type="Title" :title="Entity.Title"></mx-element>
      <div v-for="col in Columns" :key="col.Name" class="flex-row start top panel">
        <div class="t2 p1" style="width: 120px">{{ col.Title }}：</div>
        <div class="t2 p1" style="flex: 1">
          <mx-field :config="col" :value="value" :edit="false" :type="col.Type" :name="col.Name"> </mx-field>
        </div>
      </div>
 
    </div>
  </div>
</template>
<script>
export default {
  props: {
    config: Object,
    type: String,
    value: Object,
    panel: String,
    parent: Object,
    igore: Boolean,
    noSelect: Array,
    index: Number,
    actions: Array,
    name: String,
    selected: Object
  },
  computed: {
    Entity() {
      if (this.config && this.config.Type) {
        return this.$matrix.Models[this.config.Type]
      }
    },
    Columns() {
      return this.Entity.Fields.filter((f) => {
        return f.IsSearch !== -1
      })
    },
 
  },
  created(){
    console.log(this.panel,'PANEL')
  }
}
</script>
